import React, { Component } from 'react';
import { ColorButton, CustomCard } from '../../../../../neoverv';
import { Form } from 'react-bootstrap';
import EyeIcon from '../../../../../assets/images/module/general/EyeIcon.svg';
import CrossIcon from '../../../../../assets/images/module/general/CrossIcon.svg';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  setProfileData,
  changeCurrentProperty,
  setPropertyList,
} from '../../../../../redux/action/General/generalActions';
import Autoload from '../../../../../neoverv/Autoload';
import moment from 'moment';
import Spinner from 'react-bootstrap/Spinner';
import { showNotification } from '@mantine/notifications';
import { Alert, Box, Text } from '@mantine/core';
import { WarningRounded } from '@material-ui/icons';

const { loader } = Autoload.MainHelper;
var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default].general;

export class Login extends Component {
  challengeContainerRef = React.createRef();
  recaptchaWidgetRef = null;

  state = {
    email: '',
    emailErr: false,
    password: '',
    passErr: false,
    showPassword: false,
    err_invalid_login: false,
    del_invalid_account: false,
    err_invalid_role_permission: false,
    requiresChallenge: false
  };

  componentDidMount() {
    Autoload.Utils.check_auth(this);
    window.Intercom("boot", {
      api_base: "https://api-iam.intercom.io",
      app_id: "vvrs5bx3",
      Environment: window.location.hostname.includes('app') ? 'Production' : 'Staging',
    });
  }

  onInputChange = (field, e) => {
    this.setState({ [field]: e.target.value });
  };

  toggleShowPassword = (id) => {
    var x = document.getElementById(id);
    if (x.type === 'text') {
      x.setAttribute('type', 'password');
    } else {
      x.setAttribute('type', 'text');
    }
  };

  validate = () => {
    this.setState({ emailErr: false, passErr: false });
    let emailErr,
      passErr = false;
    const validEmail =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!this.state.email || !validEmail.test(this.state.email)) {
      emailErr = true;
    }
    if (!this.state.password) {
      passErr = true;
    }
    this.setState({ emailErr, passErr });
    if (emailErr || passErr) {
      return false;
    } else {
      return true;
    }
  };

  login = async (e, fallbackToken = null, isRecaptchaV2 = false) => {
    if (e) e.preventDefault();

    if (this.validate()) {
      var loader = document.getElementById('hello-housing-loader');
      loader.style.display = 'block';

      // 1. GENERATE RECAPTCHA TOKEN
      let recaptchaToken = fallbackToken;
      
      // Try invisible check if no fallback token exists yet
      if (!recaptchaToken) {
        try {
          await new Promise((resolve) => window.grecaptcha.enterprise.ready(resolve));
          recaptchaToken = await window.grecaptcha.enterprise.execute('6Lee-40sAAAAAH3KM7HK3E9rq13H69XWcptUYE2a', { action: 'login' });
        } catch (error) {
          console.error('Invisible reCAPTCHA failed:', error);
          if (loader) loader.style.display = 'none';
          showNotification({
            icon: <img src={CrossIcon} alt='red-cross'/>,
            message: 'Sicherheitsüberprüfung fehlgeschlagen. Bitte laden Sie die Seite neu.'
          });
          return;
        }
      }

      // 2. SEND TOKEN TO BACKEND
      var data = JSON.stringify({ 
        email: this.state.email, 
        password: this.state.password,
        recaptchaToken: recaptchaToken,
        isRecaptchaV2: isRecaptchaV2
      });

      Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.sign_in_bas_url + 'SignIn',
        'POST',
        data,
        null,
        false,
        true,
        false,
        this,
        'handleLogin',
        {},
        false,
        '',
        {
          'Content-Type': 'application/json',
        },
        true
      );
    }
  };

  handleLogin = (response) => {
    this.setState({err_invalid_role_permission: false});

    if (response.status === false) {
      var loader = document.getElementById('hello-housing-loader');
      if (loader) loader.style.display = 'none';

      // 3. HANDLE 403 FORBIDDEN RESPONSE (Trigger Challenge)
      if (response.message === 'FORBIDDEN') {
        this.setState({ requiresChallenge: true }, () => {
          setTimeout(() => {
            if (window.grecaptcha && this.challengeContainerRef.current) {
              if (this.recaptchaWidgetRef !== null) {
                window.grecaptcha.enterprise.reset(this.recaptchaWidgetRef);
              } else {
                this.recaptchaWidgetRef = window.grecaptcha.enterprise.render(this.challengeContainerRef.current, {
                  sitekey: '6Ldi5rYsAAAAAPMy2dv_Rxe99-WiKfE_FosVcnQN', 
                  callback: (solvedToken) => {
                    this.login(null, solvedToken, true);
                  },
                  'error-callback': () => {
                    showNotification({
                      icon: <img src={CrossIcon} alt='red-cross'/>,
                      message: 'Es gab ein Problem mit dem Captcha.'
                    });
                  }
                });
              }
            }
          }, 100);
        });
        return;
      }

      if (response.message === 'DELETED' || response.message === 'DENIED') {
        this.setState({
          del_invalid_account: true,
          err_invalid_login: false
        });
      } else {
        this.setState({
          err_invalid_login: true,
          del_invalid_account: false
        });
      }
      return;
    }

    this.setState({ requiresChallenge: false });
    this.recaptchaWidgetRef = null;

    const runRestOfLoginActivity=(encryptedToken=null)=>{
      let profileData = {
        email: response.result.email,
        firstName: response.result.firstName,
        lastName: response.result.lastName,
        address: '-',
        city: '-',
        zip: 0,
        company: '',
        phoneNumber: response.result.phoneNumber,
        id: response.result.id,
        file: '',
        propertyData: [],
        auth: { token: response.result.token, encryptedToken },
        accountId: response.result.accountId
      };
  
      Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.sign_in_bas_url + 'rolePermissions?permission=View:PropertyOwnerPortal',
        'GET',
        null,
        null,
        false,
        true,
        false,
        this,
        'handleRolePermissions',
        { profileData: profileData },
        false,
        '',
        {
          'Content-Type': 'application/json',
          Authorization: response.result.token,
        }
      );
    }

    try {
      let data = new FormData();
      data.append('text', response.result.token)
      fetch(`https://${window.location.href.includes('app.hellohousing.de') ? 'app' : 'dev'}.hellohousing.de/api/auth-api/encryption/encrypt`,
        {
          method: 'POST',
          body: data
        }).then((response)=> response.json()
        .then(data => {
          runRestOfLoginActivity(data.result);
        })
        ).catch((e)=> {
          console.log('error_data: ', e);
          runRestOfLoginActivity(null);
        });
    } catch (e) {
      console.log('error_data: ', e);
      runRestOfLoginActivity(null);
    }

    var loaderEl = document.getElementById('hello-housing-loader');
    if (loaderEl) loaderEl.style.display = 'none';
    return;
  };

  handleRolePermissions(response){
    if(response.status){
      if(response.result){
        window.Intercom('trackEvent', 'log-in');
        this.props.setProfileData(response.other.profileData);
        this.props.history.push('/dashboard');
      }else{
        this.setState({err_invalid_role_permission: true});
      }
    }else{
      this.setState({err_invalid_role_permission: true});
    }
  }

  handlePropertyData(response) {
    var propertyData = [];

    if (response.status == true && response.statuscode == 200) {
      response.result.map((tem, i) => {
        propertyData.push({
          id: Autoload.MainHelper.checkProperty(tem, 'id'),
          propertyName: Autoload.MainHelper.checkProperty(tem, 'name'), 
          propertyAddress: Autoload.MainHelper.checkProperty(
            Autoload.MainHelper.checkProperty(tem, 'propertyAdress'),
            'streetno'
          ),
          propertyCity: Autoload.MainHelper.checkProperty(
            Autoload.MainHelper.checkProperty(tem, 'propertyAdress'),
            'city'
          ), 
          propertyZipCode: Autoload.MainHelper.checkProperty(
            Autoload.MainHelper.checkProperty(tem, 'propertyAdress'),
            'zipCode'
          ), 
          propertyNoOfUnits: Autoload.MainHelper.checkProperty(tem, 'numberOfRentalUnits'), 
          propertyAreaOfUnits: Autoload.MainHelper.checkProperty(tem, 'totalRentingSpace'), 
          cutOffDate: `${Autoload.MainHelper.checkProperty(
            Autoload.MainHelper.checkProperty(tem, 'cutOffDate'),
            'day',
            '31'
          )} ${moment()
            .month(
              parseInt(
                Autoload.MainHelper.checkProperty(Autoload.MainHelper.checkProperty(tem, 'cutOffDate'), 'month', '12')
              ) - 1
            )
            .format('MMMM')}`,
          heatingType: Autoload.MainHelper.checkProperty(tem, 'heatingType'), 
          heatingTemp: Autoload.MainHelper.checkProperty(tem, 'heatingTemperature'), 
          consumptionValue: Autoload.MainHelper.checkProperty(tem, 'consumptionShare', 0), 
          energyFuelType: Autoload.MainHelper.checkProperty(tem, 'energyFuelType'), 
        });
      });
    }

    response.other.profileData.propertyData = propertyData;
    this.props.setProfileData(response.other.profileData);
    this.props.setPropertyList(propertyData);
    if (propertyData.length != 0) {
      this.props.changeCurrentProperty(propertyData[0]);
    }
    this.props.history.push('/dashboard');
  }

  handleEnterKeyPress = (e) => {
    if (e.charCode == 13) {
      e.preventDefault();
      this.login(e);
    }
  };

  goToSignup() {
    loader(true);
    window.location.href = '/signup';
    loader(false);
  }

  render() {
    return (
      <>
        <div className="center-content login-page">
          <div className="hh_loader" id="hello-housing-loader" style={{ display: 'none' }}>
            <div className="hh_loader_bg"></div>
            <Spinner animation="border" className="hh_loader_spinner" variant="primary" />
          </div>
          
          <div className="logo-section">
            <img src={Setting.logo} alt="logo" />
          </div>
          
          <div className="main-content-section">
            <CustomCard heading={`Willkommen!`} styleBody={{ width: this.state.requiresChallenge && '430px' }}>
              <Form onSubmit={this.login} noValidate>
                <Form.Group>
                  <Form.Label>{lang.text_email}</Form.Label>
                  <Form.Control
                    id="login-email"
                    name="login-email"
                    isInvalid={this.state.emailErr}
                    type="email"
                    value={this.state.email}
                    onChange={(e) => {
                      this.onInputChange('email', e);
                    }}
                    onKeyPress={this.handleEnterKeyPress}
                  />
                  <Form.Control.Feedback className="err" type="invalid">
                    {' '}
                    {lang.text_invalid_email}{' '}
                  </Form.Control.Feedback>
                </Form.Group>
                
                <Form.Group>
                  <Form.Label>{lang.text_password}</Form.Label>
                  <div className="password-field input_password" style={{ position: 'relative', top: 0, left: 0 }}>
                    <Form.Control
                      id="login-password"
                      name="login-password"
                      isInvalid={this.state.passErr}
                      type="password"
                      value={this.state.password}
                      onChange={(e) => {
                        this.onInputChange('password', e);
                      }}
                      onKeyPress={this.handleEnterKeyPress}
                    />
                    <img src={EyeIcon} onClick={() => this.toggleShowPassword('login-password')} alt="eye-icon" />
                    <Form.Control.Feedback className="err" type="invalid">
                      {' '}
                      {lang.text_invalid_password}{' '}
                    </Form.Control.Feedback>
                  </div>
                </Form.Group>

                {/* VISUAL CHALLENGE CONTAINER */}
                {this.state.requiresChallenge && (
                  <Alert color="yellow" title="Sicherheitsüberprüfung" icon={<WarningRounded />} style={{ marginTop: 16, marginBottom: 16 }}>
                    <Text size="sm" mb={10}>Bitte bestätigen Sie, dass Sie ein Mensch sind, um fortzufahren.</Text>
                    <Box ref={this.challengeContainerRef} style={{ display: 'flex', justifyContent: 'center' }}></Box>
                  </Alert>
                )}

                <div className="center-spacing">
                  <Link to="/forgotpassword">{`${lang.text_forgot_password}?`}</Link>
                  {!this.state.requiresChallenge && <ColorButton buttonConfig={{ type: 'submit' }} className="purple-btn" text={lang.text_login} />}
                </div>

                <p
                  className="text-center g-error-message"
                  style={{ display: this.state.err_invalid_login ? 'block' : 'none' }}
                >
                  {lang.text_invalid_login}
                </p>
                <p
                  className="text-center g-error-message"
                  style={{ display: this.state.err_invalid_role_permission ? 'block' : 'none' }}
                >
                  Sie haben keinen Zugriff auf diesen Bereich. Bei Fragen wenden Sie sich bitte an den <span style={{color: '#5555FF', cursor: 'pointer'}} onClick={()=> {window.location.href = 'mailto:service@hellohousing.de'; }}>hellohousing Service.</span>
                </p>
                <p
                  className="text-center g-error-message"
                  style={{ display: this.state.del_invalid_account ? 'block' : 'none' }}
                >
                  {lang.text_invalid_login}
                </p>
              </Form>
            </CustomCard>
          </div>
          
          <div className="bottom-section">
            <p>
              {lang.text_noaccount}?{' '}
              <span
                className="signup_link"
                style={{ fontWeight: 600, cursor: 'pointer' }}
                onClick={() => this.goToSignup()}
              >
                {lang.text_signup}!
              </span>
            </p>
          </div>
        </div>
      </>
    );
  }
}

const actions = {
  setProfileData,
  changeCurrentProperty,
  setPropertyList,
};

export default connect(null, actions)(Login);